import { BOOTSTRAP_APP } from './types';

export const bootstrapApp = () => ({
  type: BOOTSTRAP_APP,
  payload: null
});
